var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"schoolConsuReport"},[_c('PageNav',{attrs:{"slider":_vm.slider,"openMenu":_vm.openMenu}},[_c('el-main',[_c('reportType',{attrs:{"wayString":_vm.wayString,"placehold":_vm.placehold,"Title":_vm.Title}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }